import { CollectionUnitsUsed } from 'gql/types';
import { ControlledSelect } from 'modules/common/components';
import Select from 'modules/common/components/Select';
import { ComponentProps, FC } from 'react';
import { UseControllerProps } from 'react-hook-form';
import { getTranslation } from 'utils/getTranslation';

type Props = {
  controlled: UseControllerProps<any>;
} & ComponentProps<typeof Select>;

const t = getTranslation('donation.CollectionUnitsUsedSelect');

const collectionUnitsUsedOptions = Object.values(CollectionUnitsUsed).map(
  (value) => {
    return {
      value,
      label: t(value.charAt(0).toLowerCase() + value.slice(1)),
    };
  }
);

export const CollectionUnitsUsedSelect: FC<Props> = ({
  controlled,
  ...otherProps
}) => {
  return (
    <ControlledSelect
      {...otherProps}
      options={collectionUnitsUsedOptions}
      defaultValue={undefined}
      controlled={controlled}
      placeholder={t('selectCollectionUnitsUsed')}
    />
  );
};
